import { render, staticRenderFns } from "./DraftedAuctionsCardMobile.vue?vue&type=template&id=4fa18e1a&scoped=true&"
import script from "./DraftedAuctionsCardMobile.vue?vue&type=script&lang=js&"
export * from "./DraftedAuctionsCardMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa18e1a",
  null
  
)

export default component.exports